import React from 'react';
import { injectIntl } from 'react-intl';

import ButtonCollection from './ButtonCollection';

function parseClasses(classname = '', class_obj) {
	const classes = classname.split(' ');

	// default values if no class_obj is passed
	if(class_obj == undefined) class_obj = { };

	for(let i in class_obj) {
		switch(i) {
			case 'first':
			case 'in_top':
				if(class_obj[i]) classes.push('in_top');
				break;

			case 'icon':
				classes.push('with_icon');
				classes.push(class_obj[i]);
				break;

			case 'only_text':
				if(class_obj[i]) classes.push('only_text gui_is_not_padded');
				break;

			default:
				classes.push(class_obj[i]);
				break;
		}
	}

	return classes.join(' ');
};

export const SectionTitleWithButtons = injectIntl(({ actions, ...props }) => {
	if(actions == undefined) {
		return (
			<SectionTitle {...props} />
		)
	}

	return (
		<header class="header_with_buttons">
			<SectionTitle {...props} />

			<ButtonCollection>
				{actions}
			</ButtonCollection>
		</header>
	);
});

// We use this to simply display a SectionTitle without any extra HTML item or translation
// (mostly used to display ENG / SPA texts that are not in the labels platform):
export const SectionTitleSimple = (props) => {
	let classname = props?.classname || 'wizard_section_title';
	classname = parseClasses(classname, props._class);

	return (
		<h1 class={classname}>{props.children}</h1>
	);
};

const SectionTitle = (props) => {
	const autotranslate = props?.autotranslate ?? true;
	const children_text = (autotranslate) ? props.intl.formatMessage({ id:props.children }) : props.children;

	let classname = props?.classname ?? 'wizard_section_title';
	classname = parseClasses(classname, props._class);

	if(typeof children_text === 'object') {
		return (
			<h1 class={classname}>{children_text}</h1>
		)
	}

	return (
		<h1
			class={classname}
			dangerouslySetInnerHTML={{
				__html:children_text,
			}}
		/>
	);
};

export default injectIntl(SectionTitle);